var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticStyle:{"font-size":"50px"}},[_vm._v("🚧 ️⛏️ 🚧")]),_c('p',[_vm._v("Vi är inte riktigt klara med den här sidan än!")]),_c('p',[_vm._v(" path: "+_vm._s(_vm.route.path)),_c('br'),_vm._v(" name: "+_vm._s(_vm.route.name)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }